import { HeadlessDeliveryTypes } from '../../Types';
import {
  IMockProps,
  ErrorResponseCodeType,
  MockServiceType,
  Mocks,
} from '../../Core';
import { ENDPOINT_API_PATH, CODE_ERRORS } from '../../Apis/PartnerTokenApi';

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

/** Mocks de Erro */
let mocksErrors: IMockProps[] = [];

const generateSuccess = (type: string): IMockProps => {
  return {
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        type,
      },
    },
    configResponse: {
      status: 200,
      data: {
        code: 0,
        dataToken: {
          redirectURL: 'https://www.shoppingsmiles.com.br',
        },
      },
    },
  };
};

const generateDefaultErrors = (type: string): IMockProps[] => {
  return CODE_ERRORS.map((error: ErrorResponseCodeType<null>): IMockProps => {
    return {
      configRequest: {
        method: 'GET',
        path: ENDPOINT_API_PATH,
        body: {
          type,
        },
      },
      configResponse: {
        status: 452,
        data: {
          code: error.code,
          message: error.message,
        },
        headers: {},
      },
    };
  });
};

mocksSuccess.push(generateSuccess('smiles-shopping'));

mocksErrors = mocksErrors.concat(generateDefaultErrors('smiles-atracoes'));

export const mocksService: MockServiceType<HeadlessDeliveryTypes.HeadlessDeliveryServiceRequestType>[] =
  mocksSuccess.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
    value: request.configRequest.params,
  }));

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

Mocks.getInstance().addAll(allMocks);
